import { BackendSource } from ".";

type BaseStory = {
  id: number;
  created: string;
  updated: string;
  title: string;
  body?: string;
  url?: string;
  source: string;
  backend_source_id: number;
  backend_source: BackendSource;
  source_attributable?: string;
  isNew?: boolean;
  received_at?: EpochTimeStamp; // epoch timestamp of when the story received at the frontend
  show_deatils?: boolean;
  created_utc: string;
  source_published_time?: string; // normalized from source-specific fields at ingestion
  tickers?: string[] | string;
};

export type FlyStory = BaseStory & {
  firm?: string;
  rating_from?: string;
  rating_to?: string;
  price_target_from?: number;
  price_target_to?: number;
  tickers?: string[];
  author?: string;
};

export type BenzingaNewsStory = BaseStory & {
  tickers?: string[];
};

export type CryptoScraperStory = BaseStory;

export type TrumpTruthStory = BaseStory & {
  title: string;
  truth_social_published_time?: string;
};

type GeneralScraperStory = BaseStory & {
  backend_source: "general-scraper";
};

export type FinancialReportsEUStory = BaseStory & {
  company_name?: string;
  country_code_alpha2?: string | null;
  country_name?: string | null;
  filing_type_code?: string | null;
  filing_type_name?: string | null;
  language_code?: string | null;
  language_name?: string | null;
  document_url?: string | null;
  isins?: string[];
  lei?: string | null;
  frep_filing_id?: string;
};

export type NewsFeedItem =
  | FlyStory
  | BenzingaNewsStory
  | CryptoScraperStory
  | TrumpTruthStory
  | GeneralScraperStory
  | FinancialReportsEUStory;

/**
 * Maps backend_source to the raw field name on the SSE payload
 * that contains the original source's published time.
 * This is the ONLY place source-specific time field knowledge lives.
 */
export const SOURCE_TIME_FIELDS: Partial<Record<BackendSource, string>> = {
  "truth-social": "truth_social_published_time",
};

/** Returns the best available time for display: source_published_time if present, else created_utc */
export function getDisplayTime(story: BaseStory): string {
  return story.source_published_time ?? story.created_utc;
}
